<template>
  <div class="nao-autorizado">
    <nav-menu v-if="funcionario_id"></nav-menu> 
    
    <router-link
      v-if="!funcionario_id"
      class="w3-btn w3-white w3-block w3-border w3-margin-top" 
      to="/login"
      v-cloak>
      <b class="texto-vermelho">Ir para login</b>
    </router-link>

    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <header class="w3-container" style="padding-top:22px">
        <h5 class="texto-vermelho"><b><i class="fa fa-exclamation-triangle"></i> Não autorizado</b></h5>
      </header>

      <div class="w3-container">
        <div class="w3-row">
            <span class="texto-cinza">Você não possui autorização para acessar este recurso!</span>
        </div>  
      </div>
      <div class="w3-container" v-if="usuario_logado == 0" v-cloak>
        <router-link class="w3-btn w3-theme w3-border w3-margin-top" to="/login" id="btLogin">
          <b>Login</b>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu'
  import store from '@/ambiente/store';
  export default {
    name: 'NaoAutorizado',
    components: {
      NavMenu,
    },
    data () {
      return {
        api: process.env.API,
        usuario_logado: undefined,
        funcionario_id: ''
      }
    },
    async mounted(){
      try {
        let retorno = await JSON.parse(JSON.stringify(store.state.usuario_logado));
        
        if (!retorno) {
          this.usuario_logado = 0;
          return;
        }
        this.usuario_logado = (retorno);
        this.funcionario_id = this.usuario_logado.funcionario_id;
        return;
      } catch (error) {
        this.usuario_logado = 0;
        return;
      }
    
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/NaoAutorizado.vue